import { utils, writeFile } from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';


export const exportCombinedToExcel = (selectedUpload, userName) => {
  if (!selectedUpload) return;
  
  const { created = [], failed = [] } = selectedUpload.details;
  
  // Preparamos las hojas
  const createdWs = utils.json_to_sheet(created.map(item => ({
    'Tipo': 'Creado',
    'ID': item.id,
    'Cédula': item.ci,
    'Paciente': item.name,
    'Diagnóstico': item.diagnosis,
    'Clínica': item.medical_center,
    'Estado': 'Éxito'
  })));
  
  const failedWs = utils.json_to_sheet(failed.map(item => ({
    'Tipo': 'Fallido',
    'ID': 'N/A',
    'Cédula': item.patient_ci || 'N/A',
    'Paciente': item.patient_name || 'N/A',
    'Diagnóstico': 'N/A',
    'Clínica': 'N/A',
    'Estado': item.error,
    'Error': item.error
  })));
  
  const workbook = utils.book_new();
  utils.book_append_sheet(workbook, createdWs, "Casos Creados");
  utils.book_append_sheet(workbook, failedWs, "Casos Fallidos");
  
  // Hoja de resumen
  const summaryData = [
    ['Resumen de Carga Masiva', '', '', '', '', ''],
    ['Fecha', new Date().toLocaleDateString(), '', '', '', ''],
    ['Usuario', userName, '', '', '', ''],
    ['Archivo Original', selectedUpload.file_name, '', '', '', ''],
    ['', '', '', '', '', ''],
    ['Total Casos', selectedUpload.total_cases, '', '', '', ''],
    ['Casos Creados', selectedUpload.successful_cases, '', '', '', ''],
    ['Casos Fallidos', selectedUpload.failed_cases, '', '', '', '']
  ];
  
  const summaryWs = utils.aoa_to_sheet(summaryData);
  utils.book_append_sheet(workbook, summaryWs, "Resumen");
  
  writeFile(workbook, `reporte_carga_${new Date().toISOString().slice(0,10)}.xlsx`);
};

// Exportar a PDF
export const exportCombinedToPDF = (selectedUpload) => {
  if (!selectedUpload) return;
  
  const { created = [], failed = [] } = selectedUpload.details;
  const doc = new jsPDF();
  
  // Configuración inicial
  doc.setFont('helvetica');
  doc.setFontSize(12);
  
  // Portada
  doc.setFontSize(20);
  doc.setTextColor(40, 40, 40);
  doc.text('Reporte de Carga Masiva', 105, 30, { align: 'center' });
  
  doc.setFontSize(14);
  doc.text('Nombre del archivo: ', 20, 40);
  doc.text( selectedUpload.file_name, 105, 40, { align: 'center' });
  
  // Información general
  doc.setFontSize(12);
  doc.text(`Fecha: ${new Date(selectedUpload.upload_date).toLocaleDateString()}`, 20, 60);
  doc.text(`Usuario: ${selectedUpload.user}`, 20, 70);
  doc.text(`Total casos: ${selectedUpload.total_cases}`, 20, 80);
  doc.text(`Éxitos: ${selectedUpload.successful_cases}`, 20, 90);
  doc.text(`Fallidos: ${selectedUpload.failed_cases}`, 20, 100);
  
  // Tabla de casos creados
  if (created.length > 0) {
    doc.addPage();
    doc.setFontSize(16);
    doc.text('Casos Creados Exitosamente', 105, 20, { align: 'center' });
    
    const createdHeaders = [['ID', 'Cédula', 'Paciente', 'Clínica']];
    const createdData = created.map(item => [
      item.id,
      item.ci,
      item.name,
      //item.diagnosis,
      item.medical_center
    ]);
    
    doc.autoTable({
      startY: 30,
      head: createdHeaders,
      body: createdData,
      headStyles: { 
        fillColor: [46, 125, 50], // Verde oscuro
        textColor: 255,
        fontStyle: 'bold'
      },
      styles: { fontSize: 9 }
    });
  }
  
  // Tabla de casos fallidos
  if (failed.length > 0) {
    doc.addPage();
    doc.setFontSize(16);
    doc.text('Casos con Errores', 105, 20, { align: 'center' });
    
    const failedHeaders = [['Cédula', 'Paciente', 'Motivo del Error']];
    const failedData = failed.map(item => [
      item.patient_ci || 'N/A',
      item.patient_name || 'N/A',
      item.error
    ]);
    
    doc.autoTable({
      startY: 30,
      head: failedHeaders,
      body: failedData,
      headStyles: { 
        fillColor: [198, 40, 40], // Rojo
        textColor: 255,
        fontStyle: 'bold'
      },
      styles: { fontSize: 9 }
    });
  }
  
  doc.save(`reporte_carga_${new Date().toISOString().slice(0,10)}.pdf`);
};